var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-flex",
                        {
                          staticStyle: {
                            "margin-right": "-800px",
                            "margin-bottom": "-38px"
                          },
                          attrs: { sm3: "", md3: "", align: "rigth" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "icon",
                              staticStyle: {
                                "background-color": "rgb(255, 108, 0)",
                                "border-color": "rgb(255, 108, 0)",
                                "padding-right": "20px",
                                display: "block",
                                margin: "0 0 0 auto"
                              },
                              on: { click: _vm.crear_telco }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "color-blanco",
                                  staticStyle: { color: "white" }
                                },
                                [_vm._v("Guardar Cambios")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.id.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.id.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.id, "value", $$v)
                                  },
                                  expression: "formFields.id.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.telconame.label
                                },
                                model: {
                                  value: _vm.formFields.telconame.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.telconame,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.telconame.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|validateNumberAndSemicolon",
                                    expression:
                                      "'required|validateNumberAndSemicolon'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.telcoprefix.label,
                                  "error-messages": _vm.errors.collect(
                                    "prefix"
                                  ),
                                  "data-vv-name": "prefix",
                                  type: "text"
                                },
                                model: {
                                  value: _vm.formFields.telcoprefix.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.telcoprefix,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.telcoprefix.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.usuario.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.usuario.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.usuario,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.usuario.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.fecha.label,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.fecha.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.fecha, "value", $$v)
                                  },
                                  expression: "formFields.fecha.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.estado.label,
                                  items: _vm.estados,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.estado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.estado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.estado.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }